import React from "react";
import NavBar from "./NavBar";
import UserSideBar from "./UserSideBar";
import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import ListGroup from "react-bootstrap/ListGroup";
import "./myOrders.css";
import { useEffect, useState } from "react";

import { useSelector } from "react-redux";
import axios from "axios";

function MyOrders() {
  const user = useSelector((state) => state.user);

  const [userOrders, setUserOrders] = useState();

  useEffect(() => {
    const getOrders = async () => {
      const response = await axios.get(
        `${process.env.REACT_APP_URL_BACK}/user/orders/${user.id}`
      );
      setUserOrders(response.data);
    };
    getOrders();
  }, [user.id]);

  return (
    <>
      <NavBar />
      <div style={{ marginTop: "7rem" }} className="container">
        <div className="row">
          <div className="col-8 col-lg-3 mb-5">
            <UserSideBar />
          </div>
          {userOrders && (
            <div className="col-12 px-4 pb-5 col-lg-8 d-flex flex-column justify-content-center">
              {userOrders.map((order) => {
                return (
                  <div key={order.id} className="p-4 border mb-5">
                    <div className="d-flex justify-content-between">
                      <span className="fs-3 fw-bold">
                        Order Number : {order.id}
                      </span>
                      <span className="fs-3">
                        {order.createdAt.split("T")[0]}
                      </span>
                    </div>

                    <hr />
                    <div>
                      <ListGroup variant="flush">
                        {order.product.map((product) => {
                          return (
                            <ListGroup.Item
                              key={product.id}
                              className="border-0"
                            >
                              <div>
                                <div className="d-flex justify-content-between">
                                  <div>
                                    <strong>
                                      {product.name} x {product.quantity}
                                    </strong>
                                  </div>
                                  <div>
                                    US$ {""}
                                    {(product.price * product.quantity).toFixed(
                                      2
                                    )}
                                  </div>
                                </div>
                                <div className="d-flex">
                                  <span>Unit price: US$ {product.price}</span>{" "}
                                </div>
                              </div>
                            </ListGroup.Item>
                          );
                        })}
                      </ListGroup>
                    </div>
                    <hr />
                    <div className="d-flex justify-content-between">
                      <span className="fw-bold fs-4">Total</span>
                      <span className="fw-bold fs-4">U$S {order.total}</span>
                    </div>
                    <hr />
                    <div className="d-flex">
                      <span className="fw-bold fs-5">BILLING DETAILS</span>
                    </div>
                    <hr />

                    <div>
                      <Form className="mt-3 text-start">
                        <Row className="mb-3">
                          <Form.Group as={Col}>
                            <Form.Label>Firstname</Form.Label>
                            <Form.Control
                              type="text"
                              readOnly
                              value={user.firstName}
                            />
                          </Form.Group>

                          <Form.Group as={Col}>
                            <Form.Label>Lastname</Form.Label>
                            <Form.Control
                              type="text"
                              readOnly
                              value={user.lastName}
                            />
                          </Form.Group>
                        </Row>
                        <Row>
                          <Form.Group className="mb-3">
                            <Form.Label>Shipping address</Form.Label>
                            <Form.Control
                              type="text"
                              readOnly
                              value={user.address}
                            />
                          </Form.Group>

                          <Form.Group className="mb-3">
                            <Form.Label>Payment method</Form.Label>
                            <Form.Control
                              type="text"
                              readOnly
                              value={order.payment_method}
                            />
                          </Form.Group>
                          <Form.Group className="mb-3">
                            <Form.Label>Status</Form.Label>
                            <Form.Control
                              type="text"
                              readOnly
                              value={order.status}
                            />
                          </Form.Group>
                        </Row>
                      </Form>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default MyOrders;
